import { render, staticRenderFns } from "./CategorySlideSP.vue?vue&type=template&id=960fdeee&scoped=true&"
import script from "./CategorySlideSP.vue?vue&type=script&lang=js&"
export * from "./CategorySlideSP.vue?vue&type=script&lang=js&"
import style0 from "./CategorySlideSP.vue?vue&type=style&index=0&id=960fdeee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960fdeee",
  null
  
)

export default component.exports